import { render, staticRenderFns } from "./regulation2.vue?vue&type=template&id=5b914280&scoped=true&"
import script from "./regulation2.vue?vue&type=script&lang=js&"
export * from "./regulation2.vue?vue&type=script&lang=js&"
import style0 from "./regulation2.vue?vue&type=style&index=0&id=5b914280&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b914280",
  null
  
)

export default component.exports